module.exports = __webpack_public_path__ + "img/hyal-5@2x.438be97c.png";